var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { class: _vm.className }, [
      _c("p", [_vm._v("結果の表示まであと " + _vm._s(_vm.remaining) + " 問")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }